import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Row } from "primereact/row";
import { SelectButton } from "primereact/selectbutton";
import React from "react";
import CardSeplag from "../../../../components/CardSeplag";
import RotuloSeplag from "../../../../components/RotuloSeplag";

import { formataCasasDecimaisMostrar, formatarValor } from "../../../../utils";

export const TabAtributos = (props) => {
  let selectOptionValue = optionSimNao(props.dataFormik.flagPrioritario);
  let footerGroupPercExecFisica = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Média de execução física dos produtos:"
          colSpan={4}
          footerStyle={{ textAlign: "left", fontSize: "12px" }}
        />
        <Column
          footer={formatarValor(formataCasasDecimaisMostrar(props.percMedioTotal), 2) + "%"}
          footerStyle={{ fontSize: "12px" }}
        />
      </Row>
      <Row>
        <Column footer="Total de Produtos:" colSpan={4} footerStyle={{ textAlign: "left", fontSize: "12px" }} />
        <Column footer={props.dataTable.length} footerStyle={{ fontSize: "12px" }} />
      </Row>
    </ColumnGroup>
  );

  let footerProdutosMedia = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Média de execução física dos produtos:"
          colSpan={4}
          footerStyle={{ textAlign: "left", fontSize: "12px" }}
        />
        <Column
          footer={
            formatarValor(
              formataCasasDecimaisMostrar(
                (props.dataFormik.qtdeRealizado / props.dataFormik.qtdePrevistoOriginal) * 100
              ),
              2
            ) + "%"
          }
          footerStyle={{ fontSize: "12px" }}
        />
      </Row>
    </ColumnGroup>
  );

  function optionSimNao(prioritaria) {
    return (selectOptionValue = prioritaria === "S" ? { name: "Sim", value: "S" } : { name: "Não", value: "N" });
  }

  return (
    <>
      <form onSubmit={() => props.dataFormik.handleSubmit} className="p-grid">
        <CardSeplag>
          <div className="col-12" style={{ height: "fit-content" }}>
            {(props.visibilidade.visivelAcao ||
              props.visibilidade.visivelProduto ||
              props.visibilidade.visivelSubacao) && (
              <>
                <RotuloSeplag nome="Ação Prioritária conf. PPA/LDO">
                  <div>
                    <SelectButton
                      optionLabel="name"
                      value={props.dataFormik.flagPrioritario}
                      options={[selectOptionValue]}
                      onChange={(e) => {
                        props.changeFlagPrioritario(e.value);
                      }}
                      disabled={true}
                      style={{ width: "5em" }}
                    />
                  </div>
                </RotuloSeplag>
              </>
            )}
          </div>
        </CardSeplag>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <div className="field col-6" style={{ paddingLeft: "0px" }}>
            <CardSeplag>
              {(props.visibilidade.visivelProduto ||
                props.visibilidade.visivelSubacao ||
                props.visibilidade.visivelEtapa) && (
                <>
                  <RotuloSeplag nome="Ação:" cols="12">
                    <div>
                      {props.dataFormik.ptaFiplan.descricaoFiplanAcao
                        ? props.dataFormik.ptaFiplan.descricaoFiplanAcao
                        : "Não Possui"}
                    </div>
                  </RotuloSeplag>
                </>
              )}
              {(props.visibilidade.visivelAcao ||
                props.visibilidade.visivelProduto ||
                props.visibilidade.visivelSubacao ||
                props.visibilidade.visivelEtapa) && (
                <>
                  <hr className="hr-modal"></hr>
                  <RotuloSeplag nome="Objetivo especifico da Ação:">
                    {props.dataFormik.ptaFiplan.ptaFiplanDetalheAcao
                      ? props.dataFormik.ptaFiplan.ptaFiplanDetalheAcao.descObjetivo
                      : "Não Possui"}
                  </RotuloSeplag>
                </>
              )}
              {(props.visibilidade.visivelAcao ||
                props.visibilidade.visivelSubacao ||
                props.visibilidade.visivelEtapa) && (
                <>
                  <hr className="hr-modal"></hr>
                  <RotuloSeplag nome="Público alvo da Ação:">
                    <p
                      style={{
                        whiteSpace: "normal",
                        overflow: "visible",
                        textOverflow: "clip",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {props.dataFormik.ptaFiplan.ptaFiplanDetalheAcao
                        ? props.dataFormik.ptaFiplan.ptaFiplanDetalheAcao.descPublicoAlvo
                        : "Não Possui"}
                    </p>
                  </RotuloSeplag>
                  <hr className="hr-modal"></hr>
                  <RotuloSeplag nome="ODS Vinculada:">
                    {props.dataFormik.ptaFiplan.ptaOds &&
                      (props.dataFormik.ptaFiplan.ptaOds.length > 0 ? (
                        props.dataFormik.ptaFiplan.ptaOds.map((ods) => (
                          <p
                            key={ods.ods.idenOds}
                            style={{
                              whiteSpace: "normal",
                              overflow: "visible",
                              textOverflow: "clip",
                              whiteSpace: "nowrap",
                              margin: "0px",
                            }}
                          >
                            {ods.ods.codgOds} - {ods.ods.descOds}
                          </p>
                        ))
                      ) : (
                        <p> Sem dados de ODS.</p>
                      ))}
                  </RotuloSeplag>
                  <hr className="hr-modal"></hr>
                </>
              )}
              {(props.visibilidade.visivelAcao ||
                props.visibilidade.visivelProduto ||
                props.visibilidade.visivelSubacao ||
                props.visibilidade.visivelEtapa) && (
                <>
                  <RotuloSeplag nome="Responsável:">
                    <p
                      style={{
                        whiteSpace: "normal",
                        overflow: "visible",
                        textOverflow: "clip",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {props.dataFormik.pessoaResp
                        ? props.dataFormik.pessoaResp.nomePessoa.toUpperCase()
                        : "Não Informado"}
                    </p>
                  </RotuloSeplag>
                </>
              )}
              {(props.visibilidade.visivelAcao || props.visibilidade.visivelSubacao) && (
                <>
                  <hr className="hr-modal"></hr>
                  <RotuloSeplag nome="Unidade de Execução:">
                    <div className="field">
                      <Dropdown
                        id="rowId"
                        emptyMessage="Dados não encontrados"
                        value={props.dataFormik.unidadeSeap}
                        options={props.unidadesExecucao}
                        optionLabel="descUnidade"
                        filter
                        showClear
                        filterBy="descUnidade"
                        placeholder="Selecione uma unidade de execução"
                        onChange={(e) => {
                          props.setForm({ ...props.dataFormik, unidadeSeap: e.target.value });
                        }}
                        disabled={
                          props.isPodeEditar && (props.visibilidade.visivelAcao || props.visibilidade.visivelSubacao)
                            ? false
                            : true
                        }
                      />
                    </div>
                  </RotuloSeplag>
                </>
              )}
              <hr className="hr-modal"></hr>
              {(props.visibilidade.visivelProduto ||
                props.visibilidade.visivelSubacao ||
                props.visibilidade.visivelEtapa) && (
                <>
                  <div className="col-12">
                    <RotuloSeplag nome="Público Alvo Transversal (atual):" cols="12">
                      <div className="field">
                        <p
                          style={{
                            whiteSpace: "normal",
                            overflow: "visible",
                            textOverflow: "clip",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {props.dataFormik.ptaFiplan.ptaPublicoAlvoAcao &&
                            (props.dataFormik.ptaFiplan.ptaPublicoAlvoAcao.length > 0 ? (
                              props.dataFormik.ptaFiplan.ptaPublicoAlvoAcao.map((item) => (
                                <p
                                  key={item.idenPtaPublicoAlvo}
                                  style={{
                                    whiteSpace: "normal",
                                    overflow: "visible",
                                    textOverflow: "clip",
                                  }}
                                >
                                  {item.publicoAlvoTransversal.nomePublicoAlvoTransversal}
                                </p>
                              ))
                            ) : (
                              <p
                                style={{
                                  whiteSpace: "normal",
                                  overflow: "visible",
                                  textOverflow: "clip",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Sem informações.
                              </p>
                            ))}
                        </p>
                      </div>
                    </RotuloSeplag>
                  </div>
                  <div className="col-12">
                    <RotuloSeplag nome="Unidade de Medida:" cols="12">
                      <div className="field">
                        <p>
                          {props.dataFormik.ptaFiplan.unidadeMedida
                            ? props.dataFormik.ptaFiplan.unidadeMedida.descUnidadeMedida
                            : "Não Possui"}
                        </p>
                      </div>
                    </RotuloSeplag>
                  </div>
                </>
              )}
            </CardSeplag>
          </div>
          <div className="field col-6" style={{ paddingRight: "0px" }}>
            <CardSeplag>
              <RotuloSeplag nome="Data de Início" cols="12" className="p-fluid grid">
                <div className="p-fluid grid line-height-4">
                  <div className="field col-12 md:col-4 ">
                    <span>
                      <label
                        htmlFor="inicioprevisto"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333333",
                          marginBottom: "4px",
                          display: "inline-block",
                        }}
                      >
                        Previsto
                      </label>
                      <InputText
                        id="inicioprevisto"
                        value={props.dataFormik.ptaFiplan.dataInicioPrevisto}
                        disabled={true}
                      />
                    </span>
                  </div>
                  <div className="field col-12 md:col-4 ">
                    <span>
                      <label
                        htmlFor="iniciorealizado"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333333",
                          marginBottom: "4px",
                          display: "inline-block",
                        }}
                      >
                        Realizado
                      </label>
                      <InputMask
                        mask="99/99/9999"
                        slotChar="__/__/____"
                        placeholder="__/__/____"
                        id="inicioprealizado"
                        value={props.dataFormik.dataInicioRealizado}
                        onChange={(e) => props.setForm({ ...props.dataFormik, dataInicioRealizado: e.target.value })}
                        disabled={props.visibilidade.visivelSubacao ? false : true} //habilita somente para nivel Subacao
                      />
                    </span>
                  </div>
                  <div className="field col-12 md:col-4 ">&nbsp;</div>
                </div>
              </RotuloSeplag>
              <hr className="hr-modal"></hr>
              <RotuloSeplag nome="Data de Término" cols="12" className="p-fluid grid">
                <div className="p-fluid grid line-height-4">
                  <div className="field col-12 md:col-4 ">
                    <span>
                      <label
                        htmlFor="terminoprevisto"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333333",
                          marginBottom: "4px",
                          display: "inline-block",
                        }}
                      >
                        Previsto
                      </label>
                      <InputText
                        id="terminoprevisto"
                        value={props.dataFormik.ptaFiplan.dataTerminoPrevisto}
                        disabled={true}
                      />
                    </span>
                  </div>
                  <div className="field col-12 md:col-4 ">
                    <span>
                      <label
                        htmlFor="terminorealizado"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333333",
                          marginBottom: "4px",
                          display: "inline-block",
                        }}
                      >
                        Realizado
                      </label>
                      <InputMask
                        mask="99/99/9999"
                        slotChar="__/__/____"
                        placeholder="__/__/____"
                        id="terminoprealizado"
                        value={props.dataFormik.dataFinalRealizado}
                        onChange={(e) => {
                          props.setForm({ ...props.dataFormik, dataFinalRealizado: e.target.value });
                        }}
                        disabled={props.visibilidade.visivelSubacao ? false : true} //habilita somente para nivel Subacao
                      />
                    </span>
                  </div>
                  <div className="field col-12 md:col-4 ">&nbsp;</div>
                </div>
              </RotuloSeplag>
              <hr className="hr-modal"></hr>
              {(props.visibilidade.visivelProduto || props.visibilidade.visivelSubacao) && (
                <>
                  <hr className="hr-modal"></hr>
                  <RotuloSeplag nome="Meta Física do Produto" cols="12" className="p-fluid grid">
                    <div className="p-fluid grid line-height-4">
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label
                            htmlFor="previstoinicial"
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333333",
                              marginBottom: "4px",
                              display: "inline-block",
                            }}
                          >
                            Previsto Inicial{" "}
                          </label>
                          <InputNumber
                            id="previstoinicial"
                            value={props.dataFormik.qtdePrevistoOriginal}
                            mode="decimal"
                            minFractionDigits={3}
                            locale="pt-BR"
                            disabled={true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label
                            htmlFor="previstoatualizado"
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333333",
                              marginBottom: "4px",
                              display: "inline-block",
                            }}
                          >
                            Previsto Atualizado
                          </label>
                          <InputNumber
                            id="previstoatualizado"
                            value={props.dataFormik.ptaFiplan.qtdeProdutoPrevisto}
                            mode="decimal"
                            minFractionDigits={3}
                            locale="pt-BR"
                            disabled={true}
                          />
                        </span>
                      </div>
                      <div className="field col-12 md:col-4 ">
                        <span>
                          <label
                            htmlFor="previstorealizado"
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#333333",
                              marginBottom: "4px",
                              display: "inline-block",
                            }}
                          >
                            Realizado
                          </label>
                          <InputNumber
                            id="previstorealizado"
                            value={props.dataFormik.qtdeRealizado}
                            mode="decimal"
                            minFractionDigits={3}
                            locale="pt-BR"
                            onChange={(e) => props.setForm({ ...props.dataFormik, qtdeRealizado: e.value })}
                            disabled={!props.isPodeEditar}
                          />
                        </span>
                      </div>
                      <hr className="hr-modal"></hr>
                      <div className="field col-12">
                        <span>
                          <DataTable
                            emptyMessage=" "
                            value={null}
                            footerColumnGroup={footerProdutosMedia}
                            responsiveLayout="scroll"
                          ></DataTable>
                        </span>
                        <span>
                          <label>(Realizado/Atualizado)</label>
                        </span>
                      </div>
                    </div>
                  </RotuloSeplag>
                </>
              )}

              {props.visibilidade.visivelAcao && (
                <>
                  <DataTable
                    emptyMessage="Dados não encontrados"
                    value={props.dataTable}
                    footerColumnGroup={footerGroupPercExecFisica}
                    responsiveLayout="scroll"
                  >
                    <Column field="descElemento" header="Produto"></Column>
                    <Column field="descUnidadeMedida" header="Un. Medida"></Column>
                    <Column field="qtdeProdutoPrevisto" header="Previsto atualizado"></Column>
                    <Column field="qtdeRealizado" header="Realizado"></Column>
                    <Column field="percMedio" header="% Execução"></Column>
                  </DataTable>
                </>
              )}
            </CardSeplag>
          </div>
        </div>
        <div className="p-fluid grid">
          <div className="field col-12 md:col-9 ">&nbsp;</div>
          <div className="field col-12 md:col-3 ">
            <br></br>
            <Button
              label="Salvar"
              icon={"pi pi-check"}
              autoFocus
              className="p-button-success"
              disabled={!props.isPodeEditar}
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                props.handleSubmit();
              }}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default TabAtributos;
